export default __webpack_public_path__ + "static/media/casinoOnlineApproved.d08688b7.svg";